module.exports = "/assets/c457fdde557eb243d09ba7e96fac448f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/HX.png
// module id = 2580
// module chunks = 0